import tw from "twin.macro";

export const Wrapper = tw.footer`
    w-full fixed bottom-0 z-20 py-[1.35rem]  flex justify-center lg:justify-end gap-5 px-1.5 md:px-[6.62rem] bg-[#F5F5F5]
`;
